var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakerArkreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#02050D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.9999,
    cy: 8.00002,
    r: 5.05263,
    fill: "#414942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50751 3.21669C9.50559 3.39829 9.4748 3.57843 9.41631 3.7503L6.02711 12.7758C5.88395 13.1502 5.59949 13.453 5.23536 13.6185C4.87123 13.784 4.45675 13.7989 4.08173 13.6601C3.89374 13.5905 3.72133 13.4843 3.5744 13.3477C3.42747 13.211 3.30892 13.0466 3.22559 12.8638C3.14225 12.681 3.09577 12.4835 3.08881 12.2826C3.08185 12.0818 3.11455 11.8815 3.18504 11.6933L6.55905 2.66786C6.62988 2.48065 6.73678 2.30923 6.87365 2.16347C7.01052 2.0177 7.17467 1.90045 7.35674 1.81833C7.5388 1.73622 7.7352 1.69086 7.93473 1.68489C8.13426 1.67893 8.33301 1.71248 8.51962 1.78358C8.81051 1.8926 9.06113 2.08842 9.23775 2.34464C9.41437 2.60086 9.50851 2.90518 9.50751 3.21669V3.21669Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 12.2213C12.9147 12.5841 12.7831 12.936 12.5406 13.2134C12.2981 13.4908 11.9608 13.6756 11.5894 13.7343C11.2181 13.7931 10.8371 13.7219 10.5154 13.5337C10.1937 13.3456 9.95227 13.0527 9.8348 12.7081L6.58427 3.71834C6.51428 3.52961 6.48368 3.32939 6.49422 3.12922C6.50476 2.92905 6.55623 2.73287 6.64567 2.55193C6.73512 2.371 6.86077 2.20893 7.01542 2.07496C7.17006 1.941 7.35066 1.8378 7.5468 1.77133C7.74358 1.70422 7.95222 1.6754 8.16063 1.68656C8.36904 1.69773 8.57307 1.74865 8.76093 1.83636C8.94878 1.92408 9.11672 2.04684 9.25501 2.19756C9.39329 2.34828 9.49919 2.52396 9.56656 2.71441L12.8171 11.7194C12.8777 11.8804 12.9097 12.0501 12.9118 12.2213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakerArkreen);
export default __webpack_public_path__ + "static/media/maker-arkreen.209fe3f853245bcd4bfff87407c2157d.svg";
export { ForwardRef as ReactComponent };